export const useOverlayStore = defineStore('overlayStore', {
    state: () => ({
        isShowOverlay: false,
    }),

    actions: {
        showOverlay(): void {
            this.isShowOverlay = true
        },

        hideOverlay(): void {
            this.isShowOverlay = false
        },
    },
})
